import {
    AUTHORING_RECOMMENDATION_GROUP_STATE_APPLIED,
    AUTHORING_RECOMMENDATION_GROUP_STATE_CHOICE_REQUIRED,
    AUTHORING_RECOMMENDATION_GROUP_STATE_CONFLICTED,
} from "./authoring-recommendation-groups"

export function buildAuthoringRecommendationStateMeta(state) {
    if (state === AUTHORING_RECOMMENDATION_GROUP_STATE_APPLIED) {
        return {
            label: "Applied",
            color: "success",
            variant: "outlined",
        }
    }

    if (state === AUTHORING_RECOMMENDATION_GROUP_STATE_CONFLICTED) {
        return {
            label: "Conflict",
            color: "warning",
            variant: "filled",
        }
    }

    if (state === AUTHORING_RECOMMENDATION_GROUP_STATE_CHOICE_REQUIRED) {
        return {
            label: "Choose version",
            color: "info",
            variant: "outlined",
        }
    }

    return {
        label: "Ready",
        color: "secondary",
        variant: "filled",
    }
}
